<template>
    <div :class="['control',{controlFull:isFull }]" @click="$emit('operation', 'closeControl')">
        <div class="control-top">
        <img src="@/assets/img/live/back.png" alt="" @click.stop="back" class="control-icon">
          <span class="live-title">{{liveName}}</span>
        </div>
        <div class="control-bottom">
            <div class="control-bottom-left">
                <span class="userCount">{{userCount}} 在线</span>
            </div>
            <div class="control-bottom-right">
                <span v-show="isFull" @click.stop="$emit('operation','hotRecommend')">课程</span>
                <img @click.stop="$emit('operation','changFull')"  :src="isFull ? narrow : enlarge" class="control-icon" alt="" >
                <img @click.stop="$emit('operation','onlyPlayer')" v-show="isFull" :src="onlyPlayer ? putAway : open " class="control-icon" alt="">
            </div>
        </div>
    </div>
</template>
<script>
// eslint-disable-next-line no-undef
const { eventEmitter } = BJY;
export default {
  name: 'control',
  props: ['isFull', 'onlyPlayer'],
  data() {
    return {
      liveName: this.$route.query.liveName, // 直播间名称
      userCount: 1,
      enlarge: require('@/assets/img/live/full_screen.png'),
      narrow: require('@/assets/img/live/narrow.png'),
      putAway: require('@/assets/img/live/putAway.png'),
      open: require('@/assets/img/live/open.png'),
      iconStatus: false,
      namespace: `.live${Math.random()}`,
    };
  },
  created() {
    eventEmitter.on(
      eventEmitter.USER_COUNT_CHANGE + this.namespace,
      (e, data) => {
        this.userCount = data.userCount;
      },
    );
  },
  mounted() {
  },
  methods: {
    back() {
      if (this.isFull) {
        this.$emit('operation', 'changFull');
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
    .control {
        position: absolute;
        z-index: 3;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: calc(100vw * 0.5625);
        color:#fff;
        .control-top{
            display: flex;
            align-items: center;
            height: 100px;
            background: linear-gradient(rgba(119, 96, 96, 0.7),rgba(0,0,0,0));
            .live-title{
                width: 80%;
                height: 100%;
                overflow: hidden;
                color: white;
                font-weight: 600;
                font-size: 35px;
                line-height: 100px;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .control-bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100px;
            padding: 0 20px;
            font-size: 35px;
            background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.7));
            .control-bottom-left {
              .userCount {
                margin-left: 10px;
              }
            }
            .control-bottom-right {
                display: flex;
                align-items: center;
                height: 100%;
                span {
                    margin: 15px;
                }
            }
        }
        .control-icon{
            width: 100px;
            height: 100px;
            padding: 20px;
        }
      &.controlFull {
        width: 100%;
        height: 100%;
        transform: translateZ(100px);
      }
    }
</style>
